// extracted by mini-css-extract-plugin
export var bubble = "_3g-0";
export var container = "_3g-3";
export var contrastBorder = "_3g-4";
export var greyOut = "_3g-2";
export var initialsWrapper = "_3g-1";
export var large = "_3g-9";
export var medium = "_3g-8";
export var mediumSmall = "_3g-7";
export var mediumSmallMedium = "_3g-c";
export var micro = "_3g-5";
export var small = "_3g-6";
export var tiny = "_3g-b";
export var xTiny = "_3g-a";